(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ai-assistant"] && !Shopify.designMode) return;
  try {
    
  class AIChatScenario extends HTMLElement {
    connectedCallback() {
      const dataEl = this.querySelector('script[data-scenario]');
      let parsed;
      try {
        parsed = JSON.parse(dataEl.textContent);
      } catch (e) {
        console.warn('AIChatScenario: invalid scenario JSON', e);
        return;
      }

      if (Array.isArray(parsed)) {
        this.turns = parsed;
        this.initial = parsed[0] && parsed[0].state;
      } else {
        this.turns = Array.isArray(parsed.turns) ? parsed.turns : [];
        this.initial = parsed.initial || (this.turns[0] && this.turns[0].state);
      }
      if (this.turns.length === 0) return;

      this.chatList = this.querySelector('[data-chat-list]');
      this.swatchEl = this.querySelector('[data-swatches]');
      this.productEl = this.querySelector('[data-product-card]');
      this.logoEl = this.querySelector('[data-tee-logo]');

      this.stepPause = parseInt(this.dataset.stepPause, 10) || 1500;
      this.typingPause = parseInt(this.dataset.typingPause, 10) || 750;
      this.loopPause = parseInt(this.dataset.loopPause, 10) || 3500;

      this.applyState(this.initial, true);

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        for (const turn of this.turns) {
          this.appendUser(turn.user);
          this.appendAssistant(turn.assistant);
        }
        this.applyState(this.turns[this.turns.length - 1].state);
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting && !this.started) {
            this.started = true;
            this.run();
            observer.disconnect();
          }
        }
      }, { threshold: 0.3 });
      observer.observe(this);
    }

    disconnectedCallback() {
      this.cancelled = true;
      if (this.timer) clearTimeout(this.timer);
    }

    sleep(ms) {
      return new Promise((resolve) => {
        this.timer = setTimeout(resolve, ms);
      });
    }

    async run() {
      while (!this.cancelled && this.isConnected) {
        for (const turn of this.turns) {
          this.appendUser(turn.user);
          this.scrollDown();
          await this.sleep(600);

          const typing = this.appendTyping();
          this.scrollDown();
          await this.sleep(this.typingPause);

          typing.remove();
          this.appendAssistant(turn.assistant);
          this.applyState(turn.state);
          this.scrollDown();
          await this.sleep(this.stepPause);
        }
        await this.sleep(this.loopPause);
        this.reset();
        await this.sleep(500);
      }
    }

    appendUser(text) {
      const el = document.createElement('div');
      el.className = 'ai-msg ai-msg--user';
      el.textContent = text;
      this.chatList.appendChild(el);
      return el;
    }

    appendAssistant(text) {
      const el = document.createElement('div');
      el.className = 'ai-msg ai-msg--assistant';
      el.textContent = text;
      this.chatList.appendChild(el);
      return el;
    }

    appendTyping() {
      const el = document.createElement('div');
      el.className = 'ai-msg ai-msg--assistant ai-msg--typing';
      el.innerHTML = '<span></span><span></span><span></span>';
      this.chatList.appendChild(el);
      return el;
    }

    scrollDown() {}

    reset() {
      this.chatList.innerHTML = '';
      this.applyState(this.initial, true);
    }

    applyState(state, instant) {
      if (!state) return;
      if (state.primary && this.productEl) {
        this.productEl.style.setProperty('--product-color', state.primary);
        this.productEl.style.setProperty('--product-shadow', this.toRgba(state.primary, 0.28));
      }
      if (Array.isArray(state.swatches) && this.swatchEl) {
        this.diffSwatches(state.swatches, instant);
      }
      if (this.logoEl) {
        this.logoEl.classList.toggle('is-visible', !!state.logo);
      }
    }

    toRgba(hex, alpha) {
      const c = hex.replace('#', '');
      const num = parseInt(c.length === 3 ? c.split('').map((x) => x + x).join('') : c, 16);
      const r = (num >> 16) & 0xff;
      const g = (num >> 8) & 0xff;
      const b = num & 0xff;
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }

    diffSwatches(targetList, instant) {
      const current = Array.from(this.swatchEl.children);
      const targetKeys = targetList.map((s) => s.hex);

      for (const node of current) {
        if (!targetKeys.includes(node.dataset.hex)) {
          node.classList.remove('is-in');
          node.classList.add('is-out');
          setTimeout(() => node.remove(), instant ? 0 : 320);
        }
      }

      const stillThere = current
        .filter((n) => targetKeys.includes(n.dataset.hex))
        .reduce((map, n) => { map[n.dataset.hex] = n; return map; }, {});

      const fragment = document.createDocumentFragment();
      targetList.forEach((swatch, idx) => {
        let node = stillThere[swatch.hex];
        if (!node) {
          node = document.createElement('li');
          node.className = 'ai-window__swatch-item';
          node.dataset.hex = swatch.hex;
          node.style.setProperty('--swatch', swatch.hex);
          node.title = swatch.label || swatch.hex;
        }
        node.classList.toggle('is-primary', !!swatch.primary);
        fragment.appendChild(node);
      });

      this.swatchEl.appendChild(fragment);

      requestAnimationFrame(() => {
        this.swatchEl.querySelectorAll('.ai-window__swatch-item').forEach((n) => {
          n.classList.remove('is-out');
          n.classList.add('is-in');
        });
      });
    }

  }

  if (!customElements.get('ai-chat-scenario')) {
    customElements.define('ai-chat-scenario', AIChatScenario);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if(this.searchModal.close){
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["industries-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('industry-grid')) {
    class IndustryGrid extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('[data-industry-list]');
        this.sectionId = this.dataset.sectionId || 'industry-inline-products';
        this.templateView = this.dataset.templateView || 'industry-inline';
        this.openPanel = null;
        this.openCard = null;
        this.cache = new Map();

        this.onClick = this.onClick.bind(this);
        this.onResize = this.onResize.bind(this);
        this.onKeydown = this.onKeydown.bind(this);

        this.addEventListener('click', this.onClick);
        document.addEventListener('keydown', this.onKeydown);
        window.addEventListener('resize', this.onResize, { passive: true });
      }

      disconnectedCallback() {
        document.removeEventListener('keydown', this.onKeydown);
        window.removeEventListener('resize', this.onResize);
      }

      onClick(event) {
        const closeBtn = event.target.closest('[data-industry-close]');
        if (closeBtn && this.openPanel && this.openPanel.contains(closeBtn)) {
          event.preventDefault();
          this.close();
          return;
        }

        const card = event.target.closest('[data-industry-card]');
        if (!card || !this.contains(card)) return;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;

        event.preventDefault();
        const handle = card.dataset.collectionHandle;
        if (!handle) return;

        if (this.openCard === card) {
          this.close();
          return;
        }

        this.expand(card, handle);
      }

      onKeydown(event) {
        if (event.key === 'Escape' && this.openPanel) {
          this.close();
          this.openCard?.focus();
        }
      }

      onResize() {
        if (!this.openCard || !this.openPanel) return;
        this.repositionPanel(this.openCard, this.openPanel);
      }

      async expand(card, handle) {
        if (this.openPanel) this.close({ keepFocus: true });

        const panel = document.createElement('li');
        panel.className = 'industries-grid__panel is-loading';
        panel.setAttribute('data-industry-panel', '');
        panel.innerHTML = '<div class="industries-grid__panel-inner">Loading templates…</div>';

        this.insertPanelAfterRow(card, panel);
        this.openPanel = panel;
        this.openCard = card;
        card.setAttribute('aria-expanded', 'true');

        // Force layout, then animate open with a measured height
        requestAnimationFrame(() => {
          panel.style.maxHeight = panel.scrollHeight + 'px';
          panel.classList.add('is-open');
        });

        try {
          const html = await this.fetchPanelHtml(handle);
          if (this.openPanel !== panel) return; // Another expand happened
          const inner = panel.querySelector('.industries-grid__panel-inner');
          inner.innerHTML = html;
          panel.classList.remove('is-loading');

          // After content swap, recalculate height
          requestAnimationFrame(() => {
            panel.style.maxHeight = panel.scrollHeight + 'px';
            // Smoothly scroll into view if the panel falls below the fold
            this.maybeScrollIntoView(panel);
          });

          // Allow content to grow naturally after transition completes
          panel.addEventListener(
            'transitionend',
            () => {
              if (panel.classList.contains('is-open')) {
                panel.style.maxHeight = 'none';
              }
            },
            { once: true }
          );
        } catch (err) {
          if (this.openPanel !== panel) return;
          const inner = panel.querySelector('.industries-grid__panel-inner');
          inner.innerHTML = '<p>Could not load templates. Please try again.</p>';
          panel.classList.remove('is-loading');
        }
      }

      async fetchPanelHtml(handle) {
        if (this.cache.has(handle)) return this.cache.get(handle);
        const url =
          '/collections/' +
          encodeURIComponent(handle) +
          '?view=' +
          encodeURIComponent(this.templateView) +
          '&section_id=' +
          encodeURIComponent(this.sectionId);
        const res = await fetch(url, { headers: { Accept: 'text/html' } });
        if (!res.ok) throw new Error('Failed to fetch section ' + res.status);
        const html = await res.text();
        this.cache.set(handle, html);
        return html;
      }

      insertPanelAfterRow(card, panel) {
        const item = card.closest('[data-industry-item]');
        const lastInRow = this.findLastInRow(item);
        lastInRow.after(panel);
      }

      repositionPanel(card, panel) {
        const item = card.closest('[data-industry-item]');
        const lastInRow = this.findLastInRow(item);
        if (panel.previousElementSibling !== lastInRow) {
          // Reset height transition during reposition
          const wasOpen = panel.classList.contains('is-open');
          panel.style.maxHeight = 'none';
          lastInRow.after(panel);
          if (wasOpen) {
            requestAnimationFrame(() => {
              panel.style.maxHeight = 'none';
            });
          }
        }
      }

      findLastInRow(item) {
        const items = Array.from(this.list.querySelectorAll('[data-industry-item]'));
        const top = item.getBoundingClientRect().top;
        let last = item;
        for (const other of items) {
          if (other === item) continue;
          const rect = other.getBoundingClientRect();
          if (Math.abs(rect.top - top) < 1) {
            if (other.compareDocumentPosition(last) & Node.DOCUMENT_POSITION_PRECEDING) {
              last = other;
            }
          }
        }
        return last;
      }

      maybeScrollIntoView(panel) {
        const rect = panel.getBoundingClientRect();
        const viewportH = window.innerHeight;
        if (rect.bottom > viewportH) {
          const target =
            window.scrollY +
            rect.top -
            Math.max(80, (viewportH - panel.offsetHeight) / 3);
          window.scrollTo({ top: target, behavior: 'smooth' });
        }
      }

      close({ keepFocus = false } = {}) {
        if (!this.openPanel) return;
        const panel = this.openPanel;
        const card = this.openCard;

        panel.style.maxHeight = panel.scrollHeight + 'px';
        // Trigger collapse on next frame
        requestAnimationFrame(() => {
          panel.style.maxHeight = '0px';
          panel.classList.remove('is-open');
        });

        const remove = () => {
          panel.remove();
        };
        panel.addEventListener('transitionend', remove, { once: true });
        // Safety fallback
        setTimeout(remove, 600);

        if (card) card.setAttribute('aria-expanded', 'false');
        this.openPanel = null;
        this.openCard = null;
        if (!keepFocus && card) {
          // no-op, called when user explicitly closes via X
        }
      }
    }

    customElements.define('industry-grid', IndustryGrid);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('button-template-add')) {
    class ButtonTemplateAdd extends HTMLElement {
      static DEFAULT_BASE = 'https://admin.shopify.com/apps/live-product-options/app/options/templates';

      connectedCallback() {
        this.link = this.querySelector('[data-template-add-link]');
        if (!this.link) return;
        this.uuid = null;

        const uuid = window.Cloudlift?.options?.App?.products
          ?.map((p) => p?.config?.uuid)
          ?.find(Boolean);

        if (uuid) {
          this.setUuid(uuid);
        } else {
          this.onOptionsRendered = this.onOptionsRendered.bind(this);
          window.addEventListener('options:rendered', this.onOptionsRendered);
          this.update();
        }
      }

      disconnectedCallback() {
        if (this.onOptionsRendered) {
          window.removeEventListener('options:rendered', this.onOptionsRendered);
        }
      }

      onOptionsRendered(event) {
        this.setUuid(event?.detail?.config?.uuid);
      }

      setUuid(uuid) {
        if (!uuid || uuid === this.uuid) return;
        this.uuid = uuid;
        this.update();
      }

      buildHref() {
        if (!this.uuid) return '#';
        const base = this.dataset.targetBase || ButtonTemplateAdd.DEFAULT_BASE;
        return base + '?import=' + encodeURIComponent(this.uuid);
      }

      update() {
        const href = this.buildHref();
        if (!href || href === '#') {
          this.link.setAttribute('href', '#');
          this.link.setAttribute('aria-disabled', 'true');
          this.link.classList.add('is-disabled');
        } else {
          this.link.setAttribute('href', href);
          this.link.removeAttribute('aria-disabled');
          this.link.classList.remove('is-disabled');
        }
      }
    }

    customElements.define('button-template-add', ButtonTemplateAdd);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
